export const useSignLoteModal = (signContractLote, setShowModal) => {
  const signLote = async () => {
    signContractLote()
    setShowModal(false)
  }

  return [signLote]
}
